var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { Fragment, useState, useCallback } from "react";
import { formatLocation, isAnyNull } from "../../utils/locationUtils";
// import { SglMap } from '../../components/SglMap';

import { Button, Dialog, DialogActions, DialogContent, TextField, IconButton, DialogTitle, Select, FormControl, InputLabel, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import ZoomOutMap from '@material-ui/icons/ZoomOutMap';

function LocationWidget(_ref) {
    var onChange = _ref.onChange,
        _ref$schema$metadata = _ref.schema.metadata,
        title = _ref$schema$metadata.title,
        readonly = _ref$schema$metadata.readonly,
        required = _ref$schema$metadata.required,
        formData = _ref.formData;

    var _useState = useState(false),
        open = _useState[0],
        setOpen = _useState[1];

    var handleOpen = useCallback(function () {
        return setOpen(true);
    }, [setOpen]);
    var handleClose = useCallback(function () {
        return setOpen(false);
    }, [setOpen]);
    var classes = useStyles();

    return React.createElement(
        Fragment,
        null,
        React.createElement(TextField, {
            value: formatLocation(formData),
            InputProps: {
                endAdornment: React.createElement(
                    IconButton,
                    { onClick: handleOpen, className: classes.adornment, disabled: readonly },
                    React.createElement(ZoomOutMap, null)
                )
            },
            inputProps: {
                disabled: true
            },
            label: title + (required ? " *" : ""),
            type: "text",
            margin: "none",
            disabled: readonly,
            readOnly: true,
            fullWidth: true
        }),
        React.createElement(LocationFormDialog, {
            title: title,
            open: open,
            value: formData,
            onChange: onChange,
            handleClose: handleClose
        })
    );
}

function LocationFormDialog(_ref2) {
    var title = _ref2.title,
        value = _ref2.value,
        onChange = _ref2.onChange,
        open = _ref2.open,
        handleClose = _ref2.handleClose;

    var _useState2 = useState(value ? _extends({}, value, { epsgCode: value.epsgCode || DEFAULT_EPSG_CODE }) : { epsgCode: DEFAULT_EPSG_CODE }),
        location = _useState2[0],
        setLocation = _useState2[1];

    var _useState3 = useState({}),
        error = _useState3[0],
        setError = _useState3[1];

    var validateX = function validateX() {
        if (location.x && epsgCodeMap[location.epsgCode].unit === 'DEGREE') {
            var x = Number(location.x);
            if (x > 180 || x < -180) {
                setError(_extends({}, error, { x: 'invalido' }));
            } else {
                var _x = error.x,
                    newError = _objectWithoutProperties(error, ["x"]);

                setError(newError);
            }
        }
    };
    var validateY = function validateY() {
        if (location.y && epsgCodeMap[location.epsgCode].unit === 'DEGREE') {
            var y = Number(location.y);
            if (y > 90 || y < -90) {
                setError(_extends({}, error, { y: 'invalido' }));
            } else {
                var _y = error.y,
                    newError = _objectWithoutProperties(error, ["y"]);

                setError(newError);
            }
        }
    };
    var handleConfirm = function handleConfirm(e) {
        e.preventDefault();
        onChange(parseValues(location));
        handleClose();
    };
    return React.createElement(
        Dialog,
        { open: open, onClose: handleClose, fullWidth: true, maxWidth: "sm", keepMounted: false },
        React.createElement(
            "form",
            null,
            React.createElement(
                DialogTitle,
                null,
                title
            ),
            React.createElement(
                DialogContent,
                null,
                React.createElement(TextField, {
                    defaultValue: location.y,
                    error: !!error.y,
                    onChange: function onChange(e) {
                        return setLocation(_extends({}, location, { y: e.target.value }));
                    },
                    onBlur: validateY,
                    type: "number",
                    margin: "dense",
                    label: "Latitude",
                    fullWidth: true
                }),
                React.createElement(TextField, {
                    defaultValue: location.x,
                    error: !!error.x,
                    onChange: function onChange(e) {
                        return setLocation(_extends({}, location, { x: e.target.value }));
                    },
                    onBlur: validateX,
                    type: "number",
                    margin: "dense",
                    label: "Longitude",
                    fullWidth: true
                }),
                React.createElement(
                    FormControl,
                    { margin: "dense", fullWidth: true },
                    React.createElement(
                        InputLabel,
                        null,
                        "EPSG"
                    ),
                    React.createElement(
                        Select,
                        {
                            value: location.epsgCode || DEFAULT_EPSG_CODE,
                            onChange: function onChange(e) {
                                return setLocation(_extends({}, location, { epsgCode: e.target.value }));
                            }
                        },
                        epsgCodeList.map(function (option) {
                            return React.createElement(
                                MenuItem,
                                { key: option.value, value: option.value },
                                option.name
                            );
                        })
                    )
                )
            ),
            React.createElement(
                DialogActions,
                null,
                React.createElement(
                    Button,
                    { onClick: handleClose, color: "primary" },
                    "Cancelar"
                ),
                React.createElement(
                    Button,
                    {
                        onClick: handleConfirm,
                        disabled: Object.keys(error).length > 0,
                        type: "submit",
                        color: "primary"
                    },
                    "Confirmar"
                )
            )
        )
    );
}

var epsgCodeList = [{
    name: 'WGS84',
    value: 'EPSG:4326',
    unit: 'DEGREE'
}];

var epsgCodeMap = epsgCodeList.reduce(function (acc, epsgCode) {
    acc[epsgCode.value] = epsgCode;
    return acc;
}, {});

var DEFAULT_EPSG_CODE = 'EPSG:4326';

function parseValues(values) {
    if (isAnyNull(values)) {
        return null;
    }
    return _extends({}, values, {
        x: values.x ? Number(values.x.toString().replace(',', '.')) : null,
        y: values.y ? Number(values.y.toString().replace(',', '.')) : null,
        accuracy: values.accuracy ? Math.round(values.accuracy) : null
    });
}

var useStyles = makeStyles({
    adornment: {
        marginTop: -10,
        marginBottom: -6
    }
});

export default LocationWidget;